export default "__VITE_ASSET__BONL$erB__"